export default "__VITE_ASSET__TEZIJJ2j__"